/**
 * Created with JetBrains WebStorm.
 * User: yujy
 * Date: 16-03-29
 * Time: 上午10:41
 * To change this template use File | Settings | File Templates.
 */

export default class fvRenderPath {
    constructor(jsonContent){
      this.scaleX = 1;
      this.scaleY = 1;
    }
    roundRect(canvas,x, y, w, h, r,flag) {
        //圆半径不能为负数
        if(parseFloat(r)<0){
            r = 0.1;
        }
        canvas.beginPath();
        canvas.moveTo(parseFloat(x)+parseFloat(r), parseFloat(y));
        canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(r));
        canvas.arcTo(parseFloat(x)+parseFloat(w), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(r));
        canvas.arcTo(parseFloat(x), parseFloat(y)+parseFloat(h), parseFloat(x), parseFloat(y), parseFloat(r));
        canvas.arcTo(parseFloat(x), parseFloat(y), parseFloat(x)+parseFloat(w), parseFloat(y), parseFloat(r));
        canvas.closePath();
        if(flag == 1){
            canvas.fill();
        }else{
            canvas.stroke();
        }
    }
    rend(canvas, rect ,obj){

        
        
        if(obj==undefined){
            console.warn("渲染对象不能为空");
            return;
        }
        if(rect.height ==0 ){
            rect.height = 1;
        }
        if(rect.width == 0){
            rect.width = 1;
        }
        var config = obj.renderConfig;
        //计算渐变起始终止点
        var startPt = {
            x:0,
            y:0,
            r:0
        };;
        var endPt = {
            x:0,
            y:0,
            r:0
        };
        if(config.basicSet == 1 || config.basicSet == 2){
            if(obj.fctype == "fvRectObj"){
                if(obj.round){
                    this.roundRect(canvas,rect.left,rect.top,rect.width,rect.height,10,0)
                    canvas.clip();
                }else{
                    canvas.rect(rect.left,rect.top,rect.width,rect.height);
                    canvas.clip();
                }
                var lineWidth = rect.width-(rect.width*config.centerPoint.percentage)
                // 边框+阴影
                canvas.beginPath();
                canvas.lineWidth = lineWidth;
                canvas.shadowColor = config.color[0];
                canvas.shadowBlur = lineWidth;
                // 因线是由坐标位置向两则画的，所以要移动起点坐标位置，和加大矩形。
                canvas.strokeRect(rect.left - lineWidth/2, rect.top - lineWidth/2 , rect.width + lineWidth, rect.height + lineWidth);
                canvas.restore();
            }else{
                console.log(obj.fctype+":类型未实现矩形渐变")
            }
        }else{
            //获取渐变颜色值
            if(Array.isArray(config.color)){
                var beginColor = config.color[1].colorRgb();
                var endColor = config.color[0].colorRgb();
            }else{
                var beginColor = config.color.colorRgb();
                var endColor = config.color.colorRgb();
            }
            // 计算渐变缩放比例
            if (parseFloat(rect.width) > parseFloat(rect.height)) {
            this.scaleX = 1;
            this.scaleY = parseFloat(rect.height) / parseFloat(rect.width);
            } else {
            this.scaleY = 1;
            this.scaleX = parseFloat(rect.width) / parseFloat(rect.height);
            }
            rect.width = rect.width == 0 ? 1 : rect.width ;
            rect.height = rect.height == 0 ? 1 : rect.height ;

            rect.top = rect.top / this.scaleY
            rect.left = rect.left / this.scaleX
            rect.width = rect.width / this.scaleX
            rect.height = rect.height / this.scaleY
            this.fcGetStartEndPathPt(startPt, endPt, rect);
            this.centerpoints(rect, config, startPt, endPt);
            var grd = canvas.createRadialGradient(startPt.x , startPt.y ,startPt.r,endPt.x, endPt.y,endPt.r);
            // 渐变形状缩放
            canvas.scale(this.scaleX,this.scaleY);
            for(var i = 1; i <= config.cycletimes; i++){
                this.fcAddColorStop(grd,config,i, beginColor,endColor);
            }
            canvas.fillStyle = grd;
            canvas.imageSmoothingEnabled = true;
            canvas.fillRect(rect.left,rect.top,rect.width,rect.height);
            //canvas.fill();
            //canvas.stroke();
        }

    }
    RenderPath(canvas, rect ,obj) {

    }
    //计算中心点偏移量
    centerpoints(rect, config, startPt, endPt){
        startPt.x = startPt.x + config.centerPoint.centerX * (rect.width/2);
        startPt.y = startPt.y + config.centerPoint.centerY * (rect.height/2);

        var x = startPt.x + config.centerPoint.centerX * (rect.width/2);
        var y = startPt.y + config.centerPoint.centerY * (rect.height/2);

        var tempR = endPt.r;
        endPt.r = Math.sqrt((x - endPt.x)*(x - endPt.x) + (y - endPt.y)*(y - endPt.y))+1;//+1是确保起始点的坐标在终止点半径以内
        if(endPt.r < tempR){
            endPt.r = tempR;
        }
        startPt.r = endPt.r * config.centerPoint.percentage;
    }
    //重复次数
    fcAddColorStop(grd, config, i, beginColor, endColor ){
        if(config.spot && config.spot.length != 0){
          // spot点和color对应正好相反，排序矫正对应
            config.spot.sort(function(a, b){
              return b-a;
            });
            for(var j = 0; j < config.spot.length; j++){
                grd.addColorStop((config.spot[j]),"RGBA("+config.color[j].colorRgb()+","+config.transparent[j]/255+")");
            }
        }else{
                //console.log("RGBA("+endColor[0]+","+endColor[1]+","+endColor[2]+","+config.transparent[0]/255+")")
                grd.addColorStop((2*(i-1))/(2*config.cycletimes-1),"RGBA("+beginColor[0]+","+beginColor[1]+","+beginColor[2]+","+config.transparent[1]/255+")");
                grd.addColorStop((2*i-1)/(2*config.cycletimes-1),"RGBA("+endColor[0]+","+endColor[1]+","+endColor[2]+","+config.transparent[0]/255+")");            
        }
    }

    fcGetStartEndPathPt(startPt, endPt, inputRect){
        var centerPt = {
            x: parseInt(inputRect.left + inputRect.width / 2),
            y: parseInt(inputRect.top + inputRect.height / 2)
        }
        startPt.x =  centerPt.x;
        startPt.y =  centerPt.y;
        startPt.r = 0;

        endPt.x =  centerPt.x;
        endPt.y =  centerPt.y;
        endPt.r = Math.sqrt(inputRect.width * inputRect.width + inputRect.height * inputRect.height) / 2;
    }
}



// WEBPACK FOOTER //
// ./src/js/render/fvRenderPath.js